import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import FreeTrialGTM from '../../utils/FreeTrialGTM';
import { AlertDialog } from '@homeexchange/design';
const PreApprovedFreeTrialBlocker = ({ showTrialAlertBlocker, conversationId, closeTrialAlertBlocker }) => {
    const handleConfirmAction = () => {
        const paymentUrl = i18n.t('url:collection.subscription.payment');
        const conversationsUrl = i18n.t('user:user.infocard.unreplied_messages_url');

        FreeTrialGTM.trackPreapprovalActivateMembership();

        document.location.assign(`${paymentUrl}?as=host&redirectTo=${conversationsUrl}/${conversationId}`);
    };

    return (
        <AlertDialog
            confirmActionText={i18n.t(
                'collection:exchange-modal.activation-required-for-preapprobation.confirm-button'
            )}
            isOpen={showTrialAlertBlocker}
            dismissActionText={i18n.t(
                'collection:exchange-modal.activation-required-for-preapprobation.cancel-button'
            )}
            onConfirmAction={handleConfirmAction}
            onDismissAction={closeTrialAlertBlocker}
            title={i18n.t('collection:exchange-modal.activation-required-for-preapprobation.title')}
        >
            {i18n.t('collection:exchange-modal.activation-required-for-preapprobation.content')}
        </AlertDialog>
    );
};

PreApprovedFreeTrialBlocker.propTypes = {
    showTrialAlertBlocker: PropTypes.bool.isRequired,
    conversationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeTrialAlertBlocker: PropTypes.func.isRequired
};

export default PreApprovedFreeTrialBlocker;
